// extracted by mini-css-extract-plugin
export default {"modal":"AWMEs2SxvQdEsGkRpn3t","modalBody":"j4SqrQWoxlDLXTq8BSh0","fullPage":"ZCNkBaBJGq2JiNJ3MiT9","imgPreview":"Q0slfueRrIFHgWqJqCWX"};